import { Box } from "@mui/material";
import {
  DataGridPremium,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-premium";
import { useDispatch } from "react-redux";
import { setFormOpen, setSelectedHookID } from "../../reducers/rhapsody";
import { useHooks } from "../../redux/hook/hookHooks";
import Id from "../id/id";

/**
 * Hook
 *
 * @returns {null} Hook
 */
export default function Hooks() {
  const { hooks } = useHooks();

  const dispatch = useDispatch();

  return (
    <DataGridPremium
      rows={hooks ?? []}
      density="compact"
      columns={[
        {
          field: "id",
          headerName: "ID",
          type: "number",
          width: 60,
          renderCell: (p) => {
            if (p.id === -1) return <Box />;
            return (
              <Id startDecorator={<i className="fa-solid fa-trumpet"></i>}>
                {p.id}
              </Id>
            );
          },
        },
        { field: "name", headerName: "Name" },
        { field: "description", headerName: "Description", flex: 1 },
      ]}
      slots={{ toolbar: QuickSearchToolbar }}
      onRowClick={(e) => {
        dispatch(setSelectedHookID(e.row.id));
        dispatch(setFormOpen({ isOpen: true, formID: "hook" }));
      }}
    />
  );
}

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        display: "flex",
      }}
    >
      <GridToolbarQuickFilter
        variant="outlined"
        size="small"
        sx={{ flex: 1 }}
        fullWidth
      />
    </Box>
  );
}
